import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f14c42e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "props" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "props-header font-semibold" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Name"),
  /*#__PURE__*/_createElementVNode("div", null, "Type"),
  /*#__PURE__*/_createElementVNode("div", null, "Description")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ]))
}